import { render, staticRenderFns } from "./LocalizationSettings.vue?vue&type=template&id=6e954ad8&"
import script from "./LocalizationSettings.vue?vue&type=script&lang=ts&"
export * from "./LocalizationSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports